// extracted by mini-css-extract-plugin
module.exports =  {"text":"_7a3fb80146--text--rMX1d","data":"_7a3fb80146--data--bZPuq","percent":"_7a3fb80146--percent--BK2Zq","percent-bar":"_7a3fb80146--percent-bar--NQfZK"};